import { AfterViewInit, Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Entry } from 'contentful';
import { CookiesPolicyPage } from 'src/app/model/page/cookies-policy-page';
import { ContentfulService } from 'src/app/service/contentful.service';
import { ModelValidator } from 'src/app/validator/model-validator';
import htmlTitle from 'src/assets/json/redirects/html-title.json';

declare global {
  interface Window {
    OneTrust?: {
      initializeCookiePolicyHtml?: () => void;
    };
  }
}

@Component({
  selector: 'app-cookies-policy-page',
  templateUrl: './cookies-policy-page.component.html',
  styleUrls: ['./cookies-policy-page.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CookiesPolicyPageComponent implements OnInit, AfterViewInit, OnDestroy {
  cookiesPolicyPage: CookiesPolicyPage = {} as CookiesPolicyPage;

  private static readonly ONE_TRUST_POLL_INTERVAL_MS = 300;
  private static readonly ONE_TRUST_MAX_ATTEMPTS = 40; // ~12s total before giving up
  private oneTrustPollTimer?: ReturnType<typeof setInterval>;

  constructor(private contentfulService: ContentfulService, private titleService: Title) {}

  ngOnInit() {
    this.setBrowserTitle();

    const query = { 'fields.title': 'Cookies' };
    this.contentfulService.getPageContentResponse(query).then((cookiesPolicyPageEntries) => {
      const includedEntries: Entry<any>[] = cookiesPolicyPageEntries?.includes?.Entry ?? [];
      this.mapBanner(includedEntries);
      this.mapIntroductionBody(includedEntries);
    });
  }

  ngAfterViewInit() {
    this.renderOneTrustCookieList();
  }

  ngOnDestroy() {
    this.clearOneTrustPoll();
  }

  private setBrowserTitle() {
    const match = htmlTitle.find((title) => title.page === 'cookies-policy');
    if (match) {
      this.cookiesPolicyPage.htmlTitle = match.htmlTitle;
      this.titleService.setTitle(match.htmlTitle);
    }
  }

  private mapBanner(includedEntries: Entry<any>[]) {
    const bannerEntry = includedEntries.find((entry) => ModelValidator.isBanner(entry));
    if (bannerEntry) {
      this.mapEntryToBanner(bannerEntry);
    }
  }

  private mapEntryToBanner(entry: Entry<any>) {
    const image: any = entry.fields['image'];
    this.cookiesPolicyPage.banner = {
      title: entry.fields['title'] as string,
      subTitle: entry.fields['subTitle'] as string,
      image: image?.fields?.file?.url
    };
  }

  private mapIntroductionBody(includedEntries: Entry<any>[]) {
    const introductionSection = includedEntries.find(
      (entry) => ModelValidator.isSection(entry) && entry.fields['group'] === 'introduction'
    );
    this.cookiesPolicyPage.body = introductionSection?.fields['body'] as string;
  }


  private renderOneTrustCookieList() {
    if (this.tryRenderOneTrustCookieList()) {
      return;
    }

    let attempts = 0;
    this.oneTrustPollTimer = setInterval(() => {
      attempts++;
      if (this.tryRenderOneTrustCookieList() || attempts >= CookiesPolicyPageComponent.ONE_TRUST_MAX_ATTEMPTS) {
        this.clearOneTrustPoll();
      }
    }, CookiesPolicyPageComponent.ONE_TRUST_POLL_INTERVAL_MS);
  }

  private tryRenderOneTrustCookieList(): boolean {
    if (window.OneTrust?.initializeCookiePolicyHtml) {
      window.OneTrust.initializeCookiePolicyHtml();
      return true;
    }
    return false;
  }

  private clearOneTrustPoll() {
    if (this.oneTrustPollTimer) {
      clearInterval(this.oneTrustPollTimer);
      this.oneTrustPollTimer = undefined;
    }
  }
}
